import React, { JSX } from 'react';
import Styles from './CashbackV2.module.scss';
import ToolTip from '../../ToolTip/ToolTip';


const CashbackV2 = ({ content }: any): JSX.Element => {
  return (
    <div>
      <div className={`${Styles.cashbackcontainer} cashbackv2container`}>
        <div className={Styles.cashbackmodule}>
          <div>
            <span className={Styles.cashbackicon}>
              <img src={content?.icon?.filename} alt='cashback' width={24} height={24} />
            </span>
            <span className={Styles.cashbacktitle}>{content?.title}</span>
            <span className={Styles.cashbacktooltip}>
              {content?.tooltiptext && <ToolTip content={content?.tooltiptext} />}
            </span>
          </div>
          <div className={Styles.cashbackimage}>
            <img src={content?.image?.filename} alt='cashback' width={64} height={64} />
            <span className={Styles.cashbackdescription}>{content?.description}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CashbackV2;
